import { jsPDF } from 'jspdf';
import { Roboto } from './roboto';
import { RobotoBold } from './roboto-bold';
import { RobotoBoldItalic } from './roboto-bold-italic';
import { RobotoItalic } from './roboto-italic';

const callAddFont = function (this: any) {
  this.addFileToVFS('Roboto-normal.ttf', Roboto);
  this.addFont('Roboto-normal.ttf', 'Roboto', 'normal-normal');

  this.addFileToVFS('Roboto-italic.ttf', RobotoItalic);
  this.addFont('Roboto-italic.ttf', 'Roboto', 'normal-italic');

  this.addFileToVFS('Roboto-Bold.ttf', RobotoBold);
  this.addFont('Roboto-Bold.ttf', 'Roboto', 'bold-normal');

  this.addFileToVFS('Roboto-Bold-Italic.ttf', RobotoBoldItalic);
  this.addFont('Roboto-Bold-Italic.ttf', 'Roboto', 'bold-italic');
};

export const addFont = () => {
  jsPDF.API.events.push(['addFonts', callAddFont]);
};
